/* eslint-disable */
export const userPermissions = JSON.parse(window.USER_PERMISSIONS)
export const allPermissions = JSON.parse(window.ALL_PERMISSIONS || '[]')
